export const boardAiStudioTour = {
  key: "boardAiStudio",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-aistudio-prompt"]',
      content: t("Tour_BoardAiStudio_Prompt"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-aistudio-model"]',
      content: t("Tour_BoardAiStudio_Model"),
      placement: "top",
    },
    {
      target: '[data-tour="board-aistudio-output"]',
      content: t("Tour_BoardAiStudio_Output"),
      placement: "top",
    },
    {
      target: '[data-tour="board-aistudio-save"]',
      content: t("Tour_BoardAiStudio_Save"),
      placement: "bottom",
    },
  ],
};
